import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { JobScheduleFormValues } from './jobScheduleModal';
import { RootState } from '../../store/store';
import { ModalStatusType } from '../../types/common';

interface JobSchedulerState {
  modalStatus: ModalStatusType | null;
  savedFormValues: JobScheduleFormValues | null;
  isNavigatingFromReportDesigner: boolean;
}

const initialState: JobSchedulerState = {
  modalStatus: 'Add',
  savedFormValues: null,
  isNavigatingFromReportDesigner: false,
};

export const jobSchedulerSlice = createSlice({
  name: 'jobScheduler',
  initialState,
  reducers: {
    saveFormValues: (
      state,
      action: PayloadAction<JobScheduleFormValues & { modalStatus: ModalStatusType | null }>
    ) => {
      state.modalStatus = action.payload.modalStatus;
      state.savedFormValues = action.payload;
      state.isNavigatingFromReportDesigner = true;
    },
    clearFormValues: (state) => {
      state.modalStatus = null;
      state.savedFormValues = null;
      state.isNavigatingFromReportDesigner = false;
    },
  },
});

export const { saveFormValues, clearFormValues } = jobSchedulerSlice.actions;

export const selectSavedFormValues = (state: RootState) => state.jobScheduler.savedFormValues;
export const selectIsNavigatingFromReportDesigner = (state: RootState) =>
  state.jobScheduler.isNavigatingFromReportDesigner;
export const selectModalStatus = (state: RootState) => state.jobScheduler.modalStatus;

export default jobSchedulerSlice.reducer;
